import { render } from "./EstimatifsClientView.vue?vue&type=template&id=15b7e766&ts=true"
import script from "./EstimatifsClientView.ts?vue&type=script&lang=ts"
export * from "./EstimatifsClientView.ts?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/RC.Estimatifs/rc-estimatifs-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__